import React from "react";
import {Glyphicon, OverlayTrigger, Panel, Tooltip} from "react-bootstrap";

export default ({name, count, tooltip}) => {
    const tooltipElement = <Tooltip id={`counter-tooltip-${name}`}>{tooltip}</Tooltip>

    return (
        <Panel className="statistic-counter-value">
            <Panel.Heading>
                {tooltip && <OverlayTrigger placement="top" overlay={tooltipElement}>
                    <Glyphicon glyph="question-sign" style={{float: 'right'}} />
                </OverlayTrigger>}
                {name}
            </Panel.Heading>
            <Panel.Body>{count}</Panel.Body>
        </Panel>
    );
}
